var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":_vm.iconPath}}),_vm._t("defs")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }